import { render, staticRenderFns } from "./invitelist.vue?vue&type=template&id=96746eba&scoped=true&"
import script from "./invitelist.vue?vue&type=script&lang=js&"
export * from "./invitelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96746eba",
  null
  
)

export default component.exports